var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExperience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 68,
    viewBox: "0 0 50 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1263"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1246"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 1995",
    d: "M8.26017 41.987L7.58052 34.3695L0 32.7804L15.69 18.7029L23.9505 27.9093L8.26017 41.987Z",
    fill: "#DF3826"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 1996",
    d: "M41.4457 41.987L42.125 34.3695L49.7057 32.7804L34.0151 18.7029L25.7551 27.9093L41.4457 41.987Z",
    fill: "#DF3826"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1252"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xC3\xA1ngulo 412",
    x: 37.1719,
    y: 55.8583,
    width: 5.56321,
    height: 1.72764,
    fill: "#3DBFCD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 1997",
    d: "M42.09 55.1655H37.8162C37.7481 55.6452 37.4851 57.0482 37.0281 57.4344C37.0624 62.0105 42.9442 61.9916 42.8785 57.4344C42.4221 57.0482 42.1587 55.6452 42.09 55.1655Z",
    fill: "#F39C56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 1998",
    d: "M39.9539 47.1404L36.1597 49.4822L36.9098 54.8114C36.9098 54.8114 38.1749 56.5801 39.9539 56.5801C41.7326 56.5801 42.9977 54.8114 42.9977 54.8114L43.7472 49.4822L39.9539 47.1404Z",
    fill: "#FAB67A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 1999",
    d: "M41.7133 57.6312L39.9539 57.4302L38.1943 57.6312L36.2874 59.2027C36.9484 61.2261 38.9546 63.5753 39.9539 64.5265C40.9525 63.5753 42.9589 61.2261 43.6199 59.2027L41.7133 57.6312Z",
    fill: "#3DBFCD"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1247"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2000",
    d: "M36.6094 51.6201C35.9136 51.0235 35.4032 51.754 36.2162 53.0043C36.2162 53.0043 36.1547 53.4154 36.7367 53.4154L36.6094 51.6201Z",
    fill: "#FAB67A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2001",
    d: "M43.2987 51.6201C43.9941 51.0235 44.5044 51.754 43.6915 53.0043C43.6915 53.0043 43.7528 53.4154 43.1702 53.4154L43.2987 51.6201Z",
    fill: "#FAB67A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1248"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2002",
    d: "M36.4435 51.8866C36.4435 51.8866 36.2763 51.8116 36.1395 51.8866C36.1395 51.8866 35.974 51.9614 36.082 52.1861L36.3139 52.8215C36.3139 52.8215 36.4695 52.7578 36.5902 52.8215C36.6589 52.412 35.8773 52.0364 36.4435 51.8866Z",
    fill: "#F39C56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2003",
    d: "M43.4638 51.8866C43.4638 51.8866 43.6308 51.8116 43.7679 51.8866C43.7679 51.8866 43.9331 51.9614 43.8253 52.1861L43.5933 52.8215C43.5933 52.8215 43.4373 52.7578 43.3171 52.8215C43.2484 52.412 44.0301 52.0364 43.4638 51.8866Z",
    fill: "#F39C56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1249"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2004",
    d: "M40.5987 59.3594H39.2265L38.6499 64.984H41.1748L40.5987 59.3594Z",
    fill: "#3C3F98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2005",
    d: "M40.8149 57.4302H39.0109L38.4946 58.153L39.2265 59.3595H40.5988L41.331 58.153L40.8149 57.4302Z",
    fill: "#3C3F98"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2006",
    d: "M36.3492 51.4536L36.7375 52.6678H37.1703L36.8262 49.6201C37.4111 48.6931 38.4511 48.7206 39.954 48.8769C41.4566 48.7206 42.4963 48.6931 43.0806 49.6201L42.7367 52.6678H43.1699L43.5582 51.4536C46.4031 44.6352 33.5043 44.6353 36.3492 51.4536Z",
    fill: "#313C3B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2007",
    d: "M48.9995 61.5885C46.9522 64.3606 43.6641 66.1574 39.9542 66.1574C36.2424 66.1574 32.9519 64.3584 30.9072 61.584L30.9563 60.0011C31.6901 57.849 35.5298 56.7865 35.5298 56.7865L37.9959 61.1004L39.1265 63.4602L39.9542 64.5261L40.8185 63.4238L41.7826 61.3263L44.3759 56.7865C44.3759 56.7865 48.216 57.849 48.9504 60.0011L48.9995 61.5885Z",
    fill: "#DF3826"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1250"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2008",
    d: "M42.7349 55.8584L39.9536 57.4303L41.756 59.4052L43.8563 57.1161L42.7349 55.8584Z",
    fill: "#BEDFE1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2009",
    d: "M37.172 55.8583L39.9537 57.4302L38.1512 59.4051L36.0515 57.116L37.172 55.8583Z",
    fill: "#BEDFE1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1251"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2010",
    d: "M43.2034 56.0601C42.7349 57.6314 42.1595 61.5301 39.9539 64.5266C39.9539 64.5266 42.5511 63.5883 44.2202 61.2427C43.7174 60.7019 43.2237 60.1713 43.2237 60.1713L45.8134 57.1616L43.2034 56.0601Z",
    fill: "#A44124"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2011",
    d: "M36.7033 56.0599C37.1718 57.6313 37.7469 61.5299 39.9539 64.5265C39.9539 64.5265 37.3557 63.5882 35.6875 61.2425C36.1897 60.7018 36.6827 60.1711 36.6827 60.1711L34.094 57.1615L36.7033 56.0599Z",
    fill: "#A44124"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1255"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2012",
    d: "M8.5907 58.4622C12.1991 58.4619 14.8458 56.4067 14.8458 56.4067C14.2543 56.0234 14.3011 54.8083 14.3207 53.3652C14.4453 44.2628 2.77678 44.3925 2.85579 53.0781C2.86969 54.6448 2.96473 55.998 2.33398 56.4067C2.33398 56.4067 4.98062 58.4619 8.58939 58.4622H8.5907Z",
    fill: "#A44124"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xC3\xA1ngulo 413",
    x: 5.80884,
    y: 55.8583,
    width: 5.56234,
    height: 1.72786,
    fill: "#3DBFCD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2013",
    d: "M10.7272 55.166H6.45281C6.38493 55.6455 6.12108 57.0483 5.66504 57.434C5.69874 62.0105 11.5805 61.9918 11.5151 57.434C11.0584 57.0483 10.7955 55.6455 10.7272 55.166Z",
    fill: "#F39C56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2014",
    d: "M8.59 47.1404L4.79639 49.4819L5.54621 54.8118C5.54621 54.8118 6.81162 56.5802 8.59 56.5802C10.3687 56.5802 11.6341 54.8118 11.6341 54.8118L12.3839 49.4819L8.59 47.1404Z",
    fill: "#FAB67A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1253"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2015",
    d: "M5.24544 51.6202C4.5496 51.0235 4.0399 51.7537 4.85286 53.0046C4.85286 53.0046 4.7912 53.4159 5.37352 53.4159L5.24544 51.6202Z",
    fill: "#FAB67A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2016",
    d: "M11.9348 51.6202C12.6303 51.0235 13.1408 51.7537 12.3274 53.0046C12.3274 53.0046 12.389 53.4159 11.8064 53.4159L11.9348 51.6202Z",
    fill: "#FAB67A"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2017",
    d: "M12.2569 57.2299L8.59088 57.4314L4.92404 57.229L2.95117 58.4621C3.61168 60.4859 7.58965 63.5749 8.5899 64.5259V64.5272C9.59 63.5767 13.5688 60.4872 14.2299 58.4629L12.2569 57.2299Z",
    fill: "#3DBFCD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2018",
    d: "M16.4751 62.9249C14.4478 64.9226 11.666 66.1574 8.59115 66.1574C5.5225 66.1574 2.73584 64.9242 0.706543 62.9229L1.01913 60.0392C1.75391 57.8868 4.92414 57.229 4.92414 57.229L8.59115 64.5264L12.2575 57.229C12.2575 57.229 15.4279 57.888 16.1627 60.0408L16.4751 62.9249Z",
    fill: "#DF3826"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1254"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2019",
    d: "M5.80896 55.8583L8.59005 57.431L6.78747 59.4053L4.6875 57.116L5.80896 55.8583Z",
    fill: "#BEDFE1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2020",
    d: "M11.3721 55.8586L8.59082 57.4316L10.3934 59.4062L12.493 57.1167L11.3721 55.8586Z",
    fill: "#BEDFE1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2021",
    d: "M8.59095 46.8126C3.40352 47.1405 4.35519 51.8603 4.35519 51.8603H12.8262C12.8262 51.8603 13.7785 47.1405 8.59095 46.8126Z",
    fill: "#A44124"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2022",
    d: "M43.0869 18.6531C43.0869 28.7238 34.923 36.8873 24.8529 36.8873C14.7825 36.8873 6.61865 28.7238 6.61865 18.6531C6.61865 8.58291 14.7825 0.419312 24.8529 0.419312C34.923 0.419312 43.0869 8.58291 43.0869 18.6531Z",
    fill: "#F58A1F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2023",
    d: "M38.2694 18.6533C38.2694 26.0634 32.2626 32.0701 24.8529 32.0701C17.4428 32.0701 11.436 26.0634 11.436 18.6533C11.436 11.2435 17.4428 5.23682 24.8529 5.23682C32.2626 5.23682 38.2694 11.2435 38.2694 18.6533Z",
    fill: "#FFC514"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2024",
    d: "M32.6461 11.2209L23.3137 20.5536L17.0586 14.2996L14.2927 17.066L23.3137 26.0863L35.4124 13.9872L32.6461 11.2209Z",
    fill: "#DF3826"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1262"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\xC3\xA1ngulo 414",
    x: 20.8809,
    y: 53.2407,
    width: 7.94547,
    height: 2.46775,
    fill: "#3DBFCD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2025",
    d: "M27.9057 52.2521H21.8011C21.7034 52.9369 21.3274 54.9401 20.675 55.4915C20.7235 62.0287 29.1253 62.0012 29.0316 55.4915C28.3799 54.9401 28.0028 52.9369 27.9057 52.2521Z",
    fill: "#F39C56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2026",
    d: "M24.8539 40.7893L19.4351 44.1338L20.5058 51.7457C20.5058 51.7457 22.3133 54.2722 24.8539 54.2722C27.3939 54.2722 29.2011 51.7457 29.2011 51.7457L30.2725 44.1338L24.8539 40.7893Z",
    fill: "#FAB67A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2027",
    d: "M27.3668 55.7734L24.8537 55.4866L22.3402 55.7734L19.6172 58.018C20.5613 60.908 23.4268 64.2634 24.8537 65.6222C26.2804 64.2634 29.1455 60.908 30.0897 58.018L27.3668 55.7734Z",
    fill: "#3DBFCD"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1257"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2028",
    d: "M20.0762 47.1882C19.083 46.3353 18.3539 47.3783 19.5156 49.1651C19.5156 49.1651 19.4275 49.7527 20.2593 49.7527L20.0762 47.1882Z",
    fill: "#FAB67A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2029",
    d: "M29.6309 47.1882C30.6244 46.3353 31.3533 47.3783 30.1916 49.1651C30.1916 49.1651 30.2799 49.7527 29.4475 49.7527L29.6309 47.1882Z",
    fill: "#FAB67A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1258"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2030",
    d: "M19.8406 47.5679C19.8406 47.5679 19.6016 47.4612 19.4053 47.5679C19.4053 47.5679 19.1698 47.675 19.3231 47.9965L19.6543 48.9044C19.6543 48.9044 19.8779 48.8128 20.0495 48.9044C20.1475 48.3189 19.0311 47.7819 19.8406 47.5679Z",
    fill: "#F39C56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2031",
    d: "M29.8667 47.5679C29.8667 47.5679 30.1057 47.4612 30.3021 47.5679C30.3021 47.5679 30.5372 47.675 30.3846 47.9965L30.0528 48.9044C30.0528 48.9044 29.8294 48.8128 29.6575 48.9044C29.5598 48.3189 30.6762 47.7819 29.8667 47.5679Z",
    fill: "#F39C56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1259"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2032",
    d: "M25.7749 58.2418H23.8151L22.9917 66.2752H26.598L25.7749 58.2418Z",
    fill: "#DF3826"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2033",
    d: "M26.084 55.4866H23.5071L22.77 56.5186L23.8153 58.2417H25.7752L26.8204 56.5186L26.084 55.4866Z",
    fill: "#DF3826"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2034",
    d: "M19.7054 46.9493L20.2593 48.6842H20.8776L20.3862 44.3312C21.2224 43.0074 22.7073 43.0464 24.8537 43.2697C27.0008 43.0464 28.4848 43.0074 29.3203 44.3312L28.8286 48.6842H29.4476L30.0014 46.9493C34.0653 37.2112 15.6419 37.2113 19.7054 46.9493Z",
    fill: "#313C3B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2035",
    d: "M37.7727 61.4254C34.8494 65.3848 30.1532 67.9516 24.8542 67.9516C19.5525 67.9516 14.8532 65.3819 11.9324 61.4193L12.0027 59.1582C13.0512 56.0845 18.5352 54.5673 18.5352 54.5673L22.1064 60.8148L23.7248 64.2334L24.8542 65.621L26.0354 64.1514L27.6443 60.7379L31.1703 54.5673C31.1703 54.5673 36.654 56.0845 37.7032 59.1582L37.7727 61.4254Z",
    fill: "#3C3F98"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1260"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2036",
    d: "M28.8263 53.2407L24.8538 55.4865L27.4281 58.3069L30.4276 55.0375L28.8263 53.2407Z",
    fill: "#BEDFE1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2037",
    d: "M20.8809 53.2407L24.8538 55.4865L22.2788 58.3069L19.2795 55.0375L20.8809 53.2407Z",
    fill: "#BEDFE1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo 1261"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2038",
    d: "M29.4954 53.5291C28.8258 55.7733 28.0046 61.3418 24.8535 65.6222C24.8535 65.6222 28.5637 64.2812 30.947 60.9314C30.2289 60.159 29.5245 59.401 29.5245 59.401L33.222 55.1028L29.4954 53.5291Z",
    fill: "#2B286B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2039",
    d: "M20.2112 53.5291C20.8805 55.7733 21.7023 61.3418 24.8534 65.6222C24.8534 65.6222 21.1429 64.2812 18.7603 60.9314C19.478 60.159 20.1821 59.401 20.1821 59.401L16.4846 55.1028L20.2112 53.5291Z",
    fill: "#2B286B"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperience);
export default __webpack_public_path__ + "static/media/experience.09e07220b54ff6c6cb83b1b85aef2b27.svg";
export { ForwardRef as ReactComponent };